import React, { useState, useEffect } from 'react';

import { generateKey } from 'Helpers/misc';

import Button from 'CommonComponents/Button';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

const TYPE_SECTION = 'section';
const TYPE_ITEM = 'item';
const STATUS_IN_PROGRESS = 1;

const DescriptionComponent = ({ setState, state, disabled }) => {
    const [val, setVal] = useState(state);

    return (
        <input
            type="text"
            className="form-control"
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onBlur={() => setState(val)}
            disabled={disabled}
            placeholder="Write explanation"
        />
    );
};

export default function EvaluateCompaniesForm(props) {
    const [request, setRequest] = useState(false);
    const [template, setTemplate] = useState({});
    const [items, setItems] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [scorer, setScorer] = useState({});
    const [criteria, setCriteria] = useState([]);
    const [sectionWeighting, setSectionWeighting] = useState({});

    const [scores, setScores] = useState({});
    const [canBeSubmitted, setCanBeSubmitted] = useState(false);
    const [showCriteria, setShowCriteria] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        let res = false;
        if (Object.keys(scores).length > 0) {
            res = true;

            Object.keys(scores.companies).forEach((companyId) => {
                const companyData = scores.companies[companyId];
                Object.keys(companyData.items).forEach((itemId) => {
                    const itemData = companyData.items[itemId];
                    if (itemData.score === null || itemData.score === '') {
                        res = false;
                    }
                });
            });
        }

        setCanBeSubmitted(res);
    }, [scores]);

    const fetchData = () => {
        setRequest(true);
        axios
            .untranslated()
            .get(props.fetchUrl)
            .then((response) => {
                const itemList = [...response.data.items];

                setTemplate({ ...response.data.template });
                setItems(itemList);
                setCompanies([...response.data.companies]);
                setScorer({ ...response.data.scorer });
                setCriteria([...response.data.criteria]);
                setScores(JSON.parse(JSON.stringify(response.data.scorer.scores)));
                calculateSectionWeighting(itemList);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const calculateSectionWeighting = (items) => {
        const result = {};
        let id = null;
        items.forEach((item) => {
            if (item.type === TYPE_SECTION) {
                id = item.id;
                result[id] = 0;
            }

            if (id && item.type !== TYPE_SECTION) {
                result[id] += parseInt(item.weighting);
            }
        });

        setSectionWeighting(result);
    };

    const changeScoreHandler = (e, companyId, itemId) => {
        const value = e.target.value;
        const data = JSON.parse(JSON.stringify(scores));
        data.companies[companyId].items[itemId].score = value;

        setScores(data);
    };
    const changeDescriptionHandler = (value, companyId, itemId) => {
        const data = { ...scores };
        data.companies[companyId].items[itemId].description = value;

        setScores(data);
    };

    const saveAsDraft = () => {
        if (scorer.status > STATUS_IN_PROGRESS) {
            return;
        }

        setRequest(true);
        axios
            .put(props.saveUrl, { scores })
            .then((res) => {
                fetchData();
            })
            .catch((er) => {
                setRequest(false);
                console.log(e.response);
            });
    };

    const handleSubmit = () => {
        if (scorer.status > STATUS_IN_PROGRESS) {
            return;
        }

        setRequest(true);
        axios
            .put(props.submitUrl, { scores })
            .then((res) => {
                fetchData();
            })
            .catch((er) => {
                setRequest(false);
                console.log(e.response);
            });
    };

    const parseDescription = (description) => {
        return description.split('\n');
    };

    const toggleCriteriaVisibility = () => {
        setShowCriteria(!showCriteria);
    };

    return (
        <>
            <div className="row d-flex mt-3 mb-1 px-3">
                <div className="col-12">
                    <h4 className="text-blue">Scoresheet</h4>
                </div>
            </div>
            <div className="row d-flex px-3">
                <div className="col-6">
                    <h4 className="text-blue">{scorer.user?.name || ''}</h4>
                </div>
                {scorer.status <= STATUS_IN_PROGRESS && (
                    <div className="col-6 d-flex justify-content-end">
                        <Button variant="primary" disabled={request} onClick={saveAsDraft}>
                            {$t('Save As Draft')}
                        </Button>

                        <Button variant="primary" className={'ml-5'} disabled={request || !canBeSubmitted} onClick={handleSubmit}>
                            {$t('Submit')}
                        </Button>
                    </div>
                )}
                {scorer.status > STATUS_IN_PROGRESS && (
                    <div className="col-6 d-flex justify-content-end">
                        <h4 className="text-success">{scorer.status_label}</h4>
                    </div>
                )}
            </div>

            <div className="row justify-content-center text-blue">
                <div className="col-10">
                    <div className="card border-0 rounded-15px bg-white shadow h-100">
                        <div className="card-header cursor-pointer d-flex justify-content-between" onClick={toggleCriteriaVisibility}>
                            <h4>{$t('Scoring Criteria')}</h4>
                            <div>
                                {!showCriteria ? (
                                    <ChevronDownIcon className="tw-w-2.5 tw-h-2.5" aria-hidden="true" />
                                ) : (
                                    <ChevronUpIcon className="tw-w-2.5 tw-h-2.5" aria-hidden="true" />
                                )}
                            </div>
                        </div>
                        <div className="card-body">
                            {showCriteria && (
                                <div id="sorting-criteria-table" className="scoring-criteria-table table-responsive shadow mt-3">
                                    <table className="table table-bordered no-footer text-center m-0 font-weight-bold">
                                        <thead>
                                            <tr className="text-blue bg-white">
                                                <th style={{ width: '15%' }} className="border-top-0 border-left-0">
                                                    {$t('Marks')}
                                                </th>
                                                <th style={{ width: '75%' }} className="border-top-0">
                                                    {$t('Description')}
                                                </th>
                                                <th style={{ width: '10%' }} className="border-top-0">
                                                    {$t('Score')}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {criteria.map((row) => {
                                                return (
                                                    <tr className="bg-white font-weight-bold text-blue" key={generateKey()}>
                                                        <td>{row.mark}</td>
                                                        <td className="text-left font-weight-normal">
                                                            <ul>
                                                                {parseDescription(row.description).map((item, index) => {
                                                                    return <li key={index}>{item}</li>;
                                                                })}
                                                            </ul>
                                                        </td>
                                                        <td>{row.score}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row d-flex px-3">
                <div className="col-12">
                    {companies.map((company) => {
                        return (
                            <div className="my-5" key={generateKey()}>
                                <h4 className="ml-5 text-center text-blue">Company: {company.name || ''}</h4>
                                <div className="company-table table-responsive shadow">
                                    <table className="my-0 table table-bordered no-footer text-center">
                                        <thead>
                                            <tr className="text-blue bg-white">
                                                <th className="py-3 border-top-0 border-left-0" style={{ width: '20%' }}>
                                                    {$t('Assessment Criteria')}
                                                </th>
                                                <th className="py-3 border-top-0" style={{ width: '10%' }}>
                                                    {$t('Weighting')}
                                                </th>
                                                <th className="py-3 border-top-0" style={{ width: '10%' }}>
                                                    {$t('Score (0-5)')}
                                                </th>
                                                <th className="py-3 border-top-0 border-right-0" style={{ width: '60%' }}>
                                                    {$t('Explanation for score')}
                                                </th>
                                            </tr>
                                        </thead>
                                        {Object.keys(scores).length > 0 && (
                                            <tbody>
                                                {items.map((item) => {
                                                    return (
                                                        <tr className="cursor-pointer suppliers-table-main-tr text-blue" key={generateKey()}>
                                                            <td
                                                                className={
                                                                    'py-3 border-bottom-0 border-left-0 ' +
                                                                    (item.type === TYPE_SECTION ? 'text-left font-weight-bold' : '')
                                                                }
                                                            >
                                                                {item.name}
                                                            </td>
                                                            <td className={'py-3 border-bottom-0 ' + (item.type === TYPE_SECTION ? 'font-weight-bold' : '')}>
                                                                {item.type === TYPE_ITEM ? item.weighting : sectionWeighting[item.id] || ''} %
                                                            </td>
                                                            <td className="py-3 border-bottom-0">
                                                                {item.type === TYPE_ITEM && (
                                                                    <div className="form-group">
                                                                        <select
                                                                            className="form-control"
                                                                            onChange={(e) => {
                                                                                changeScoreHandler(e, company.id, item.id);
                                                                            }}
                                                                            disabled={scorer.status > STATUS_IN_PROGRESS}
                                                                            value={
                                                                                scores.companies[company.id].items[item.id].score === null
                                                                                    ? ''
                                                                                    : scores.companies[company.id].items[item.id].score
                                                                            }
                                                                        >
                                                                            {scores.companies[company.id].items[item.id].score === null && (
                                                                                <option value={''}>Evaluate</option>
                                                                            )}
                                                                            {criteria.map((obj) => {
                                                                                return (
                                                                                    <option value={obj.score} key={generateKey()}>
                                                                                        {obj.score}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="py-3 border-bottom-0 border-right-0">
                                                                {item.type === TYPE_ITEM && (
                                                                    <div className="form-group">
                                                                        <DescriptionComponent
                                                                            state={scores.companies[company.id].items[item.id].description || ''}
                                                                            setState={(val) => {
                                                                                changeDescriptionHandler(val, company.id, item.id);
                                                                            }}
                                                                            disabled={scorer.status > STATUS_IN_PROGRESS}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
}
